'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _recompose = require('recompose');

var _reactRedux = require('react-redux');

var _milanoteForm = require('../../../components/form/milanoteForm');

var _milanoteForm2 = _interopRequireDefault(_milanoteForm);

var _loadingTransitionDecorator = require('../../../components/loaders/loadingTransitionDecorator');

var _loadingTransitionDecorator2 = _interopRequireDefault(_loadingTransitionDecorator);

var _LoadingTransitionDisplay = require('../../../components/loaders/LoadingTransitionDisplay');

var _LoadingTransitionDisplay2 = _interopRequireDefault(_LoadingTransitionDisplay);

var _UpdateCardForm = require('./UpdateCardForm');

var _UpdateCardForm2 = _interopRequireDefault(_UpdateCardForm);

var _UpdateCardProcessing = require('./UpdateCardProcessing');

var _UpdateCardProcessing2 = _interopRequireDefault(_UpdateCardProcessing);

var _UpdateCardSuccess = require('./UpdateCardSuccess');

var _UpdateCardSuccess2 = _interopRequireDefault(_UpdateCardSuccess);

var _paymentActions = require('../payment/paymentActions');

var _paymentSelector = require('../payment/paymentSelector');

var _paymentConstants = require('../payment/paymentConstants');

require('./UpdateCardModal.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref) {
    var setInitial = _ref.setInitial,
        setSuccess = _ref.setSuccess,
        setLoading = _ref.setLoading;
    return {
        onSubmit: function onSubmit(values) {
            return dispatch((0, _paymentActions.submitCreditCardUpdateForm)(_extends({}, values, { setInitial: setInitial, setSuccess: setSuccess, setLoading: setLoading })));
        },
        dispatchClearCard: function dispatchClearCard() {
            return dispatch((0, _paymentActions.clearPrefilledCard)());
        }
    };
};

var UpdateCardModal = function UpdateCardModal(props) {
    return _react2.default.createElement(
        'div',
        { className: 'UpdateCardModal' },
        _react2.default.createElement(_LoadingTransitionDisplay2.default, _extends({}, props, {
            InitialComponent: _UpdateCardForm2.default,
            LoadingComponent: _UpdateCardProcessing2.default,
            SuccessComponent: _UpdateCardSuccess2.default }))
    );
};

var enhance = (0, _recompose.compose)(_loadingTransitionDecorator2.default, (0, _reactRedux.connect)(null, mapDispatchToProps), (0, _milanoteForm2.default)({ form: _paymentConstants.PAYMENT_FORM_NAME, fieldsConfig: _paymentConstants.CARD_UPDATE_FORM_FIELDS }, _paymentSelector.paymentFormValuesSelector));

exports.default = enhance(UpdateCardModal);


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/updateCard/UpdateCardModal.js
// module id = 2105
// module chunks = 0